module.exports = "<div class=\"inmodal\">\n  <div class=\"color-line\"></div>\n  <div class=\"modal-header\">\n    <h4 class=\"modal-title\">Funding Documents</h4>\n  </div>\n  <div class=\"modal-body\">\n    <document-viewer\n      document-api-url=\"{{documentApiUrl}}\"\n      updatecount=\"updateDocumentCount\"\n    >\n    </document-viewer>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"cancel()\">Close</button>\n  </div>\n</div>\n\n\n\n\n\n";


//////////////////
// WEBPACK FOOTER
// ./client/common/modals/fundingDocumentModal/fundingDocumentModal.html
// module id = 946
// module chunks = 0